import { useState } from "react";
import { CalendarPlus, Loader2 } from "lucide-react";
import { downloadIcs, type IcsReminder } from "@/lib/maintenance-ics";

export function MaintenanceIcsButton({
  build,
  label = "Add reminders to calendar (.ics)",
  className = "",
}: {
  build: () => { reminders: IcsReminder[]; calendarName: string; filename: string };
  label?: string;
  className?: string;
}) {
  const [busy, setBusy] = useState(false);

  const onClick = () => {
    if (busy) return;
    setBusy(true);
    try {
      const { reminders, calendarName, filename } = build();
      if (reminders.length) downloadIcs(reminders, calendarName, filename);
    } catch {
      // ignore — button returns to idle
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      className={`inline-flex items-center gap-2 rounded-md border border-primary px-4 py-2 text-sm font-semibold text-primary transition-colors hover:bg-primary/10 disabled:opacity-60 ${className}`}
    >
      {busy ? (
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
      ) : (
        <CalendarPlus className="h-4 w-4" aria-hidden />
      )}
      {label}
    </button>
  );
}
